import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SirenResponse, SirenEntity } from '../model';

export const AUTH_SERVICE = new InjectionToken('Authentication Service');

export interface AuthenticationService {
  token: string;
  authenticate(): Observable<SirenResponse>;
  refresh(): Observable<SirenEntity>;
  setAuthResponse(authResponse?: SirenResponse, reAuthResponse?: SirenResponse): void;
}